import React, { useMemo } from 'react'
import i18next from 'i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

export const InternalTransferTransactionSubType = {
  PAYMENT_IN: 'PAYMENT_IN',
  PAYMENT_OUT: 'PAYMENT_OUT',
} as const

interface InternalTransferProps {
  amountWithCurrency: string
  transactionReference: string
  transactionType: string
  transactionSubType: string
}

const InternalTransfer = ({
  amountWithCurrency,
  transactionReference,
  transactionType,
  transactionSubType,
}: InternalTransferProps) => {
  const amountWithCurrencyLabel = useMemo(() => {
    const isPayin = transactionSubType === InternalTransferTransactionSubType.PAYMENT_IN
    const isPayout = transactionSubType === InternalTransferTransactionSubType.PAYMENT_OUT

    if (isPayin) {
      return i18next.t(`transactions.sideBar.paymentInAmountReceived`)
    } else if (isPayout) {
      return i18next.t(`transactions.sideBar.amountWithdrawn`)
    } else {
      return i18next.t(`transactions.sideBar.amount`)
    }
  }, [transactionSubType])

  return (
    <Box gapY={8}>
      {amountWithCurrency && (
        <DataListItem
          id="amount-with-currency"
          testId="amount-with-currency"
          title={amountWithCurrencyLabel}
          body={amountWithCurrency}
        />
      )}
      {transactionType && (
        <DataListItem
          id="transaction-type"
          testId="transaction-type"
          title={i18next.t('transactions.sideBar.transactionType')}
          body={transactionType?.replace('Bvnk', 'BVNK')}
        />
      )}
      {!!transactionReference && (
        <DataListItem
          id="transaction-reference"
          testId="transaction-reference"
          title={i18next.t('transactions.sideBar.reference')}
          body={ellipseMiddleText(transactionReference, 20, 10)}
          copyText={transactionReference}
        />
      )}
    </Box>
  )
}
export default InternalTransfer
